import React, { useState } from 'react'
import asktheexpertdashboard from "../../../../assets/images/asktheexpertdashboard.svg";
import { Trans, useTranslation } from 'react-i18next';
import Sign_out_squre from "../../../../assets/images/Sign_out_squre.svg";
import { Footer } from '../../../common/footer/footer';
import { QuestionAnswerCardJSX } from '../../../common/questionAnswerCard/questionAnswerCard';
import Sidebar from "../sidebar/sidebar.js";
import { Link } from "react-router-dom";
import dropbox from "../../../../assets/images/dropbox.svg";
import { Pagination } from '../../../common/pagination/uiPagination.js';

const ExpertAnswerJsx = (props) => {
  const { t } = useTranslation();
  const {
 questionData, answerData, onPaginationButtonClick, page
  } = props;
  const itemsPerPage = 10

  const [currentPage] = useState(1);

  const currentItems = answerData?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  // {t("PRINT.TITLE")}
  return (
    <>
    <section className="main_customer_dashboard">
      <section className="entiredashboard maincustomerdash expert-dashboard">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-4 col-sm-4">
              <div className="dashboardleftpanel">
                <div className="dashboardlinkpop">
                  <Sidebar />
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-sm-8">
              <div className="dashboardrightpanel">
                <div className="dashboardrightpanelinner">
                  <div className="dashboardrightpannerinnerleft">
                  <h2 className="h2_style font-weight-600 d-block d-lg-none d-sm-none d-md-none"><span className="headingicon d-block d-lg-none d-sm-none d-md-none "><img alt="article" src={asktheexpertdashboard} /></span>QnA</h2>
                  <h2 className="h2_style font-weight-600 newts"><Trans i18nKey="expertDashboard.QNATABTWO" ></Trans></h2>
                 <h5 className="h5_style"><Trans i18nKey="expertDashboard.QNA_PENDING_TEXT" ></Trans></h5> 
                   
                  </div>
                  <div className="dashboardrightpannerinnerright">
                    <div className="signout">
                      <a href="#logout">
                        <img src={Sign_out_squre} alt={'icon'} /><span className="title">Logout</span>
                      </a>
                    </div>
                   
                  </div>
              
                <div className="myexpertnav myaccountnav qnanav martop40">
                  <ul>
                    <li > <Link to={'/expertQna'}><span>{questionData?.length}</span>{t("expertDashboard.QNATABONE")}</Link></li>
                    <li className="active"><Link to={'/expertAnswer'}><span>{answerData?.length}</span>{t("expertDashboard.QNATABTWO")}</Link></li>
                  </ul>
                </div>
                <div className="questioninner mt-4">                
                  {currentItems && currentItems.length ?
                    <> {
                      currentItems?.map((data, index) => {
                        return <div>
                        <QuestionAnswerCardJSX 
                           imgurl={data?.askExpertQuestionUserResponse?.icon}
                           listexpertimageUrl={data?.expert?.imageUrl}
                           listexpertfirstName={data?.expert?.firstName}
                           listexpertlastName={data?.expert?.lastName}
                           listfirstName={data?.expert?.firstName}
                           listlastName={data?.expert?.firstName}
                           listaskExpertQuestionUserResponsequestion={data.askExpertQuestionUserResponse.question}
                           listanswer={data.answer}
                           questiondate= {data?.createdAt}
                           listaskExpertCategoryone={data.askExpertQuestionUserResponse.parentInstitutionCategory}
                           listaskExpertCategory={data.askExpertQuestionUserResponse.parentInstitutionCategory?.replace(/\s+/g, '')}
                        isAnswer={true}
                        />
                        </div>
                       
                      })
                    }
                     <section className="newpagination"> <Pagination
                          currentPage={currentPage}
                          page={page}
                          allOffersData={answerData}
                          currentItems={currentItems}
                          onPaginationButtonClick={onPaginationButtonClick}
                          itemsPerPage={itemsPerPage}
                        /></section>
                    </> : 
                    <div className="dropdefault text-center">
                    <div className="dropdefaultimage">
                      <img src={dropbox}  alt={'icon'}/>
                    </div>
                    <div className="dropdefaulttext">
                      <h5>You don't have any Answer. </h5>
                    </div>
                  </div>
                    }
 
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </section> <Footer />
      </section>
     

    </>

  );
};

export default ExpertAnswerJsx;
